// {Componente}{Verbo}{Acción}

export const SOFTSEGUROS_VENDEDORES_GET_REQUEST = 'SOFTSEGUROS_VENDEDORES_GET_REQUEST';
export const SOFTSEGUROS_VENDEDORES_GET_SUCCESS = 'SOFTSEGUROS_VENDEDORES_GET_SUCCESS';
export const SOFTSEGUROS_VENDEDORES_GET_ERROR = 'SOFTSEGUROS_VENDEDORES_GET_ERROR';
